<template>
    <router-link
        active-class="text-white bg-gray-700"
        class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-200 rounded-md space-x-4 | hover:text-white hover:bg-gray-700 | focus:outline-none focus:text-white focus:bg-gray-700 | transition ease-in-out duration-150"
        :exact="false"
        tag="a"
        :to="{ name: view }"
    >
        <svg
            class="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :d="icon"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
            />
        </svg>

        <span>
            {{ text }}
        </span>
    </router-link>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: true,
            },
            view: {
                type: String,
                required: true,
            },
        },

        computed: {
            icon() {
                if (this.view === 'orders') {
                    return 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z';
                }

                return 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z';
            },
        },
    };
</script>
